export const currency = (string) => Number(string).toLocaleString('nl-NL', {
	style: 'currency',
	currency: 'EUR'
});


// WEBPACK FOOTER //
// ./src/filters/number-filter.js